import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@env/environment';
import {Observable, ReplaySubject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {

  constructor(private http: HttpClient) {
  }

  logo: ReplaySubject<any> = new ReplaySubject<any>(1);

  getCustomerWithPrefix(prefix): Observable<any> {
    return this.http.get(environment.PUBLIC_API_URL + `/customers/${prefix}`);
  }

  getLogo(company): Observable<any> {
    return this.http.get(`${environment.API_URL}/public/customer/${company}/logo`);
  }

  getFdeAppUrl(os: 'windows' | 'macos') {
    return `${environment.API_URL}/app/installer/download?os=${os}&version=latest`;
  }
}